import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { AlertBox, InfoIcon } from '@spotahome/ui-library';

import { useHotspotItem } from '../../../context/HotspotsContext';

import './FiltersExposedInfoBox.scss';

export const INFO_KEYS = {
  availabilities: {
    content: 'search.wizard.step.dates.description',
    title: 'search.wizard.step.dates.title'
  },
  propertyType: {
    content: 'search.wizard.step.propertyTypes.description',
    title: 'search.wizard.step.propertyTypes.title'
  },
  budget: {
    content: 'search.wizard.step.prices.description',
    title: 'search.wizard.step.prices.title'
  }
};

const FiltersExposedInfoBox = ({ filterName }) => {
  const { isHotspotActive } = useHotspotItem(filterName);
  const { content, title } = INFO_KEYS[filterName];

  return isHotspotActive() ? (
    <div className="filters-exposed-info-box">
      <AlertBox
        icon={<InfoIcon />}
        title={trans(title)}
        message={trans(content)}
      />
    </div>
  ) : null;
};

FiltersExposedInfoBox.propTypes = {
  filterName: PropTypes.oneOf(Object.keys(INFO_KEYS)).isRequired
};

export default FiltersExposedInfoBox;
